import React from 'react';

const FormButton = ({
  children,
  onClick,
  type = "button",
  className = ""
}) => {
  const fixedStyles = "w-40 h-11 py-2 rounded-xl transition-colors font-medium shadow-sm flex justify-center items-center";

  return (
    <button
      type={type}
      onClick={onClick}
      className={`${fixedStyles} ${className}`}
    >
      {children}
    </button>
  );
};

export default FormButton;